import { mapState } from 'vuex'
import { getInputEndpointUUID, getOutputEndpointUUID } from '../utils/scenario-view.utils'
export default {
    mounted () {
        this.addNode()
    },
    computed: {
        ...mapState('debug', ['instance'])
    },
    props: {
        node: null,
        scope: null,
        index: {
            type: Number
        }
    },
    methods: {
        repaint () {
            const connections = this.instance.getConnections()
            connections.forEach((connection) => {
                connection.setType('fci-transparent')
                this.instance.repaint(connection.endpoints[1].element)
            })
            setTimeout(() => {
                connections.forEach((connection) => {
                    connection.setType('fci-normal')
                    this.instance.repaintEverything()
                })
            }, 330)
        },
        addNode () {
            this.addInputEndpoint()
            this.addOutPutEndpoint()
        },
        addInputEndpoint () {
            const endpointData = {
                uuid: getInputEndpointUUID(this.node.id, this.index),
                anchor: 'Top',
                endpoint: 'Blank',
                connectionType: 'fci-connection',
                scope: this.scope,
                parameters: {
                    nodeId: this.node.id,
                    index: this.index
                }
            }
            this.instance.addEndpoint(this.$refs.nodeRef, endpointData)
            this.instance.setDraggable(this.$refs.nodeRef, false)
        },
        addOutPutEndpoint () {
            const endpointData = {
                uuid: getOutputEndpointUUID(this.node.id, this.index),
                anchor: 'Bottom',
                endpoint: 'Blank',
                scope: this.scope,
                connectionType: 'fci-connection',
                parameters: {
                    nodeId: this.node.id,
                    index: this.index
                }
            }
            this.instance.addEndpoint(this.$refs.nodeRef, endpointData)
        }

    }
}
